<template>
    <div>
        <span v-if="label" :class="['label', {'bolder': bolderLabel}]">{{ label }}</span>
        <v-combobox
            v-model="model"
            :filter="filter"
            :hide-no-data="!search"
            :items="tags"
            :search-input.sync="search"
            hide-selected
            aria-autocomplete="none"
            :label="placeholder"
            multiple
            small-chips
            :solo="solo" flat
            dense
            hide-details
            color="secondary"
        >
            <template v-slot:no-data>
                <v-list-item>
                    <span class="subheading mr-1">{{ $t('common.create').toLowerCase() }}:</span>
                    <v-chip color="secondary" label small>
                        {{ search }}
                    </v-chip>
                </v-list-item>
            </template>
            <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    label small
                    class="tag-chip-pill"
                >
                    {{ item }}
                    <v-icon x-small @click="parent.selectItem(item)" right>
                        $close
                    </v-icon>
                </v-chip>
            </template>
            <template v-slot:item="{ index, item }">
                <v-chip color="grey" dark label small>
                    {{ item.text }}
                </v-chip>
            </template>
        </v-combobox>
    </div>

</template>

<script>
import _map from 'lodash/map'

export default {
    name: "KimsaTagsPicker",
    props: {
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default() {
                return this.$t('inputs.tags_picker_placeholder')
            }
        },
        defaultTags: {
            type: Array,
            default: () => []
        },
        bolderLabel: {
            type: Boolean,
            default: false
        },
        forceValue: {
            type: Boolean,
            default: false
        },
        solo: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            activator: null,
            attach: null,
            editing: null,
            editingIndex: -1,
            tags: [],
            nonce: 1,
            menu: false,
            model: [],
            search: null,
        }
    },
    mounted() {
        this.setDefaults()
    },
    methods: {
        reset() {
            const vm = this
            vm.tags = []
            vm.model = []
            vm.nonce = 1
            vm.search = null
            vm.menu = false
        },
        setDefaults() {
            const vm = this
            // console.log('vm.defaultTags',vm.defaultTags)
            const defaults = Array.isArray(vm.defaultTags) ? vm.defaultTags : []
            if (defaults.length > 0 || vm.forceValue) vm.model = defaults
        },
        edit(index, item) {
            if (!this.editing) {
                this.editing = item
                this.editingIndex = index
            } else {
                this.editing = null
                this.editingIndex = -1
            }
        },
        filter(item, queryText, itemText) {
            if (item.header) return false

            const hasValue = val => val != null ? val : ''

            const text = hasValue(itemText)
            const query = hasValue(queryText)

            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        },
    },
    watch: {
        model(val, prev) {
            const vm = this
            if (val.length === prev.length) return
            vm.model = val.map(v => {
                if (typeof v === 'string') {
                    v = {text: v}
                    vm.tags.push(v)
                    vm.nonce++
                }
                return v
            })

            vm.$nextTick(function () {
                vm.$emit('change', _map(vm.model, 'text'))
            })
        },
        defaultTags() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    display: block;
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    margin-bottom: 6px;
}

.bolder {
    font-weight: 700;
}

.tag-chip-pill {
    background: rgba(51, 153, 153, .15) !important;
    border: 1px solid var(--v-accent-base);
    color: var(--v-secondary-base) !important;
    font-size: 13px;
}

.tag-chip-pill >>> .v-icon {
    color: var(--v-secondary-base) !important;
}

::v-deep input {
    font-size: var(--fs-input);
}

::v-deep .v-label {
    font-size: var(--fs-input);
}

</style>